<template>
  <div class="k-page-content">
    <el-tabs v-model="activeName" class="box-eltab">
      <el-tab-pane label="媒体管理" name="first">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
              <el-form
                :inline="true"
                :model="searchForm"
                size="mini"
                ref="searchForm"
                :rules="rules.searchForm"
              >
                <el-form-item label="媒体名称" prop="name">
                  <el-input v-model="searchForm.name" placeholder="请填写媒体名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="doSearch">查询</el-button>
                  <el-button type="primary" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-toolbar" style="margin-top:0;">
                <div>
                  <el-button type="primary" size="mini" @click="handelAddOpen">添加媒体</el-button>
                </div>
              </div>
              <div class="k-table-con">
                <el-table
                  :data="tableData.data"
                  style="width: 100%"
                  border
                  stripe
                  ref="table"
                  highlight-current-row
                  @sort-change="sortChange"
                  :height="tableHeight"
                >
                  <el-table-column fixed prop="name" label="媒体名称" width="100"></el-table-column>
                  <el-table-column prop="appId" label="APPID" width="200"></el-table-column>
                  <el-table-column prop="secret" label="秘钥" width="200"></el-table-column>
                  <el-table-column prop="url" label="授权地址" width="250"></el-table-column>
                  <el-table-column prop="redirect_url" label="回调地址" width="250"></el-table-column>
                  <el-table-column prop="server" label="逻辑SERVER" width="100">
                    <template slot-scope="scope">
                      <el-tag
                        v-if="scope.row.server"
                        type="success"
                        :size="size"
                      >{{scope.row.server}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="create_time" label="创建时间" width="180" sortable="custom"></el-table-column>
                  <el-table-column prop="update_time" label="修改时间" width="180" sortable="custom"></el-table-column>
                  <el-table-column fixed="right" label="操作" min-width="200">
                    <template slot-scope="scope">
                      <el-button @click="handleTableEditOpen(scope.row)" type="text" size="small">编辑</el-button>
                      <el-button
                        @click="handleTableDelete(scope.row)"
                        type="text"
                        size="small"
                        class="c-danger"
                      >删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  ref="pagination"
                  @current-change="handleCurrentChange"
                  :current-page="tableData.current_page | number"
                  :page-size="tableData.per_page | number"
                  layout="total, prev, pager, next, jumper"
                  :total="tableData.total | number"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" size="40%">
      <el-form
        :model="addForm"
        ref="addForm"
        :size="size"
        :rules="rules.addForm"
        label-width="120px"
      >
        <div class="drawer-header">
          <div class="header-title">
            <span>添加媒体</span>
            <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-form-item label="媒体名称" prop="name">
            <el-input v-model="addForm.name" placeholder="请填写媒体名称"></el-input>
          </el-form-item>
          <el-form-item label="APPID" prop="appId">
            <el-input v-model="addForm.appId" placeholder="请输入APPID"></el-input>
          </el-form-item>
          <el-form-item label="授权秘钥" prop="secret">
            <el-input v-model="addForm.secret" placeholder="请输入授权秘钥"></el-input>
          </el-form-item>
          <el-form-item label="Auth授权地址" prop="url">
            <el-input v-model="addForm.url" placeholder="请输入Auth2.0授权地址"></el-input>
          </el-form-item>
          <el-form-item label="回调地址" prop="redirect_url">
            <el-input v-model="addForm.redirect_url" placeholder="请输入回调地址"></el-input>
          </el-form-item>
          <el-form-item label="逻辑模型" prop="server">
            <el-input v-model="addForm.server" placeholder="请输入逻辑模型"></el-input>
          </el-form-item>
          <el-form-item label="模型" prop="model">
            <el-input v-model="addForm.model" placeholder="请输入模型"></el-input>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" @click="handelAdd" :size="size">提交</el-button>
          <el-button :size="size" @click="addFormVisiable = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" size="40%">
      <el-form
        :model="editForm"
        ref="editForm"
        :size="size"
        :rules="rules.editForm"
        label-width="110px"
      >
        <div class="drawer-header">
          <div class="header-title">
            <span>编辑媒体</span>
            <i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-form-item label="媒体名称" prop="name">
            <el-input v-model="editForm.name" placeholder="请填写媒体名称"></el-input>
          </el-form-item>
          <el-form-item label="APPID" prop="appId">
            <el-input v-model="editForm.appId" placeholder="请输入APPID"></el-input>
          </el-form-item>
          <el-form-item label="授权秘钥" prop="secret">
            <el-input v-model="editForm.secret" placeholder="请输入授权秘钥"></el-input>
          </el-form-item>
          <el-form-item label="Auth授权地址" prop="url">
            <el-input v-model="editForm.url" placeholder="请输入Auth2.0授权地址"></el-input>
          </el-form-item>
          <el-form-item label="回调地址" prop="redirect_url">
            <el-input v-model="editForm.redirect_url" placeholder="请输入回调地址"></el-input>
          </el-form-item>
          <el-form-item label="逻辑模型" prop="server">
            <el-input v-model="editForm.server" placeholder="请输入逻辑模型"></el-input>
          </el-form-item>
          <el-form-item label="模型" prop="model">
            <el-input v-model="editForm.model" placeholder="请输入模型"></el-input>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" @click="handleTableEdit" :size="size">提交</el-button>
          <el-button :size="size" @click="editFormVisiable = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data() {
    return {
      loading: false,
      addFormVisiable: false,
      editFormVisiable: false,
      checkSkVisiable: false,
      activeName: 'first',
      size: 'mini',
      options: {
        menus: [],
        actions: []
      },
      searchForm: {
        name: ''
      },
      resetSearch: {
        name: ''
      },
      addForm: {
        name: '',
        appId: '',
        secret: '',
        url: '',
        redirect_url: '',
        server: '',
        model:''
      },
      editForm: {
        name: '',
        appId: '',
        secret: '',
        url: '',
        redirect_url: '',
        server: '',
        model:''
      },
      checkSkForm: {
        id: '',
        secret_key: ''
      },
      checkSk: {
        show: false,
        text: '显示'
      },
      rules: {
        searchForm: {
          type: [
            {
              required: true,
              message: '请选择搜索类型',
              trigger: ['change', 'blur']
            }
          ],
          name: [
            {
              max: 50,
              message: '请填写正确的角色名称，长度不超过 50',
              trigger: ['change', 'blur']
            }
          ]
        },
        addForm: {
          name: [
            {
              required: true,
              message: '请填写媒体名称',
              trigger: ['change', 'blur']
            },
            {
              max: 10,
              message: '请填写正确的媒体名称，长度不超过 10',
              trigger: ['change', 'blur']
            }
          ],
          appId: [
            {
              required: true,
              message: '请填写APPID',
              trigger: ['change', 'blur']
            }
          ],
          secret: [
            {
              required: true,
              message: '请填写秘钥',
              trigger: ['change', 'blur']
            }
          ],
          url: [
            {
              required: true,
              message: '请填写Auth2.0授权地址',
              trigger: ['change', 'blur']
            }
          ],
          redirect_url: [
            {
              required: true,
              message: '请填写回调地址',
              trigger: ['change', 'blur']
            }
          ]
        },
        editForm: {
          name: [
            {
              required: true,
              message: '请填写正确的角色名称，长度不超过 50',
              trigger: ['change', 'blur']
            },
            {
              max: 50,
              message: '请填写正确的角色名称，长度不超过 50',
              trigger: ['change', 'blur']
            }
          ],
          level: [
            {
              required: true,
              message: '请选择搜索角色等级',
              trigger: ['change', 'blur']
            }
          ],
          status: [
            {
              required: true,
              message: '请选择搜索角色状态',
              trigger: ['change', 'blur']
            }
          ]
        }
      },
      tableData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      }
    }
  },
  computed: {
    tableHeight: function() {
      return window.innerHeight - 320
    },
    apiMainHeight: function() {
      var height = window.innerHeight - 200
      return {
        height: height + 'px',
        border: '1px solid #DCDFE6',
        'margin-bottom': '10px'
      }
    }
  },
  methods: {
    reset: function() {
      this.searchForm = this.resetSearch
      this.doSearch()
    },
    handleSearch: function(params, page, prop, order) {
      this.$refs['searchForm'].validate(
        function(valid) {
          if (valid) {
            this.loading = true

            var param = Object.assign({}, params)

            param['page'] = page ? page : 1
            param['prop'] = prop ? prop : 'id'
            param['order'] = order ? order : 'desc'
            this.$api.http.get('media/mediaList', param).then(res => {
              if (res.code === 0) {
                this.tableData = res.data
              } else {
                var message = '查询应用列表信息失败！'
                if (res.message) {
                  message = res.message
                }
                this.$message({
                  showClose: true,
                  message: message,
                  type: 'error'
                })
              }
              this.loading = false
            })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },

    // 执行查询
    doSearch: function(event) {
      var query = this.searchForm
      query['_t'] = Date.parse(new Date())
      this.$router.push({ path: this.$route.path, query: query })
    },

    // 排序
    sortChange: function(e) {
      var order
      var prop = e.prop
      if (e.order == 'ascending') {
        order = 'asc'
      } else if (e.order == 'descending') {
        order = 'desc'
      } else {
        prop = this.resetSearch.prop
        order = this.resetSearch.order
      }
      this.handleSearch(this.searchForm, 1, prop, order)
    },

    // 改变当前页 page
    handleCurrentChange: function(val) {
      this.handleSearch(this.searchForm, val)
    },

    // 添加角色
    handelAddOpen: function() {
      this.addFormVisiable = true
    },
    // 添加角色
    handelAdd: function() {
      this.$refs['addForm'].validate(
        function(valid) {
          if (valid) {
            this.loading = true
            this.$api.http.post('media/mediaAdd', this.addForm).then(res => {
              var message = '添加媒体信息成功！'
              var msgType = 'success'
              if (res.code === 0) {
                this.tableData.data.unshift(res.data)
                this.addFormVisiable = false
              } else {
                message = res.message ? res.message : '添加媒体信息失败！'
                msgType = 'error'
              }
              this.$message({
                showClose: true,
                message: message,
                type: msgType
              })
              this.loading = false
            })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },
    // 打开编辑角色弹窗
    handleTableEditOpen: function(row) {
      this.loading = true
      this.$api.http.get('media/getMediaInfo', { id: row.id }).then(res => {
        if (res.code === 0) {
          this.editForm = res.data
          this.editFormVisiable = true
        } else {
          var message = res.message ? res.message : '查询媒体信息失败！'
          var msgType = 'error'
          this.$message({
            showClose: true,
            message: message,
            type: msgType
          })
        }
        this.loading = false
      })
    },

    // 编辑角色
    handleTableEdit: function() {
      this.$refs['editForm'].validate(
        function(valid) {
          if (valid) {
            this.loading = true
            this.$api.http.post('media/mediaEdit', this.editForm).then(res => {
              if (res.code === 0) {
                var data = this.tableData.data
                data.forEach(
                  function(item, index) {
                    if (item.id == res.data.id) {
                      this.$set(data, index, res.data)
                    }
                  }.bind(this)
                )

                this.$message({
                  showClose: true,
                  message: '修改角色信息成功！',
                  type: 'success'
                })
                this.editFormVisiable = false
              } else {
                var message = '修改角色信息失败！'

                if (res.message) {
                  message = res.message
                }

                this.$notify({
                  showClose: true,
                  message: message,
                  type: 'warning'
                })
              }
              this.loading = false
            })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },
    // 删除角色
    handleTableDelete: function(row) {
      this.$confirm('此操作将永久删除该媒体, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        function() {
          this.loading = true
          this.$api.http.post('media/mediaDelete', { id: row.id }).then(res => {
            if (res.code === 0) {
              var data = this.tableData.data
              data.forEach(
                function(item, index) {
                  if (item.id == row.id) {
                    this.$delete(data, index)
                  }
                }.bind(this)
              )

              this.$message({
                showClose: true,
                message: '删除媒体信息成功！',
                type: 'success'
              })
            } else {
              var message = '删除媒体信息失败！'

              if (res.message) {
                message = res.message
              }

              this.$message({
                showClose: true,
                message: message,
                type: 'error'
              })
            }
            this.loading = false
          })
        }.bind(this)
      )
    },
    // 生成查询参数
    makeParams: function(query) {
      var params = {}
      params['type'] = query.type ? query.type : this.resetSearch.type
      params['name'] = query.name ? query.name : this.resetSearch.name
      params['level'] = query.level ? query.level : this.resetSearch.level

      this.searchForm = params
      return params
    }
  },
  mounted: function() {
    var params = this.makeParams(this.$route.query)
    this.handleSearch(params)
  },
  beforeRouteUpdate: function(to, from, next) {
    var params = this.makeParams(to.query)
    this.handleSearch(params)
    next()
  }
}
</script>